import { TableHeaderData } from "../../types";

export const Top10BondHoldingsHeaderData: TableHeaderData[] = [
    {
        id: "bondName",
        label: "DEBT NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: false
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: false
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN",
        align: "center",
        isSortable: false
    },
    {
        id: "investedOn",
        label: "INVESTED ON",
        align: "center",
        isSortable: false
    },
    {
        id: "periodOfInvestment",
        label: "PERIOD OF INVESTMENT",
        align: "center",
        isSortable: false
    },
]

export const Top10BondsHeaderData: TableHeaderData[] = [
    {
        id: "bondName",
        label: "DEBT NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "aum",
        label: "AUM",
        align: "left",
        isSortable: false
    },
    {
        id: "irr",
        label: "ABSOLUTE RETURN %",
        align: "center",
        isSortable: false
    },
    {
        id: "expemseRatio",
        label: "EXPENSE RATIO",
        align: "center",
        isSortable: false
    },
]

export const BondsQuantativeHeaderData: TableHeaderData[] = [
    {
        id: "metricName",
        label: "METRIC NAME",
        align: "left",
        isSortable: false
    },
    {
        id: "value",
        label: "VALUE",
        align: "center",
        isSortable: false
    },

]

export const HoldingDetailsHeaderData: TableHeaderData[] = [
    {
        id: "scheme",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    {
        id: "investedValue",
        label: "INVESTED VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "marketValue",
        label: "MARKET VALUE",
        align: "center",
        isSortable: true
    },
    {
        id: "gainLoss",
        label: "GAIN/LOSS",
        align: "center",
        isSortable: true
    },
]

export const TransactionDetailsHeaderData: TableHeaderData[] = [
    {
        id: "scheme",
        label: "SCHEME",
        align: "left",
        isSortable: false
    },
    {
        id: "schemeCategory",
        label: "SCHEME CATEGORY",
        align: "center",
        isSortable: false
    },
    {
        id: "transactionAmount",
        label: "TRANSACTION AMOUNT",
        align: "center",
        isSortable: true
    },
    {
        id: "transactionType",
        label: "TRANSACTION TYPE",
        align: "center",
        isSortable: true
    },
    {
        id: "transactionDate",
        label: "TRANSACTION DATE",
        align: "center",
        isSortable: true
    },
]